import * as buttonText from './ui-button-text.js'

export default async function procOpen(params) {
    const { app, w, h, cards, select } = params;

    // Show button
    const text = '占い結果を見る';
    await new Promise(resolve => {
        const button = buttonText.gen(app, text, async () => {
            button.destroy();
            resolve();
        });
        button.y = h * 0.9;
        button.zIndex = 100;
    });

    // Show cards
    const card = select.card;
    card.zIndex = 100;
    const s = card.__scale * 2.5;
    await anime({targets: card.scale, x: s, y: s, easing: 'linear', duration: 500}).finished;

    if (! card.__isUpright) card.rotation = Math.PI;
    card.setSide(true);
}